import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SettingsState, Units, UserInfo, UserSettingsType } from "./settings.types";
import { RootState } from "../store";
import axios, { AxiosError } from "axios";
import api from "../../api";

const initialState: SettingsState = {
  settings: {
    id: 0,
    castAndCureCost: 0,
    foilCost: 0,
    foilWidth: 0,
    polymerCost: 0,
    units: "metric",
    userId: 0
  },
  user: {
    id: 0,
    email: "",
    phone: "",
    nickname: "",
    isAdmin: false,
    machines: []
  }
};

const slice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setSettings: (state, action: PayloadAction<UserSettingsType>) => {
      state.settings = action.payload;
    },
    updateSettings: (state, action: PayloadAction<Partial<UserSettingsType>>) => {
      state.settings = { ...state.settings, ...action.payload };
    },
    setUser: (state, action: PayloadAction<Partial<UserInfo>>) => {
      state.user = { ...state.user, ...action.payload };
    },
    resetSettings: (state) => {
      Object.assign(state, initialState);
    }
  }
});

export const { setSettings, updateSettings, setUser, resetSettings } = slice.actions;

export const settingsState = (state: RootState) => state.settings;

export default slice.reducer;
